import React from 'react';
import { FormattedNumber } from '../../../../../../components';

interface LegendItemProps {
  width: string;
  value?: number;
  options?: Intl.NumberFormatOptions;
  style?: React.CSSProperties;
}

export const LegendItem = ({
  width,
  value,
  options,
  style,
}: LegendItemProps) => (
  <div style={{ width, textAlign: 'center' }}>
    {value !== undefined && (
      <FormattedNumber value={value} options={options} style={style} />
    )}
  </div>
);
